<section class="flex flex-col gap-4 p-4">
  <soft-ds-accordion variant="boxed" multi="true">
    <soft-ds-accordion-item [expanded]="true">
      <soft-ds-accordion-header>
        <soft-ds-accordion-leading variant="tinted">
          <soft-ds-icon name="fa-regular fa-users" />
        </soft-ds-accordion-leading>
        <soft-ds-accordion-title variant="overline">Teilnehmer</soft-ds-accordion-title>
      </soft-ds-accordion-header>
      <soft-ds-accordion-content>
        <soft-workflow-participants
          class="workflow-participants"
          [roles]="workflow()?.currentAction?.participants?.currentRoles ?? []"
          (addParticipant)="onAddParticipant($event)"
          (deleteParticipant)="removeParticipant($event)"
        />
      </soft-ds-accordion-content>
    </soft-ds-accordion-item>

    <soft-ds-accordion-item [expanded]="false">
      <soft-ds-accordion-header>
        <soft-ds-accordion-leading variant="tinted">
          <soft-ds-icon name="fa-regular fa-comment" />
        </soft-ds-accordion-leading>
        <soft-ds-accordion-title variant="overline">Kommentare</soft-ds-accordion-title>
      </soft-ds-accordion-header>
      <soft-ds-accordion-content>
        <div class="flex flex-col gap-2 flex-1">
          @for (comment of comments(); track comment.id) {
            <div
              class="flex justify-between p-2 hover:bg-hover rounded-lg transition-all group"
            >
              <div>
                <div class="flex items-center justify-between">
                  <div class="flex items-center gap-3">
                    <div
                      class="w-8 h-8 rounded-full bg-primary/10 text-primary flex items-center justify-center text-xs font-bold border border-primary/20 group-hover:scale-110 transition-transform"
                    >
                      {{ comment?.username ?? '' | slice: 0 : 1
                      }}{{ (comment?.username ?? '').split(' ')[1] | slice: 0 : 1 }}
                    </div>

                    <div class="flex items-center gap-2">
                      <span class="text-sm font-medium">
                        {{ comment?.username ?? 'null' }}
                      </span>
                      <span class="text-xs text-gray-400">
                        {{ comment?.createdAt | date: 'dd.MM. HH:mm' }}
                      </span>
                    </div>
                  </div>
                </div>

                <p class="text-sm text-gray-700 pl-11 mt-1 leading-snug">
                  {{ comment?.message }}
                </p>
              </div>

              <button
                type="button"
                class="opacity-0 group-hover:opacity-100 p-1 text-gray-400 hover:text-red-500 transition-all hover:cursor-pointer"
                (click)="deleteComment(comment.id)"
              >
                <soft-icon name="fa-regular fa-xmark" size="xs" />
              </button>
            </div>
          } @empty {
            <soft-ds-empty-state [description]="'Noch keine Kommentare'" />
          }
          <div
            class="mt-4 flex flex-col gap-2 animate-in fade-in slide-in-from-bottom-1 duration-200"
          >
            <soft-multiline-input
              placeholder="Kommentar hinzufügen…"
              [lines]="5"
              [value]="newCommentText()"
              (keydown.enter)="addComment()"
              (valueChange)="newCommentText.set($event)"
            />

            <div class="flex justify-end">
              <button
                type="button"
                class="soft-button primary rounded"
                (click)="addComment()"
                [disabled]="!newCommentText()?.trim()"
              >
                Hinzufügen
              </button>
            </div>
          </div>
        </div>
      </soft-ds-accordion-content>
    </soft-ds-accordion-item>

    <soft-ds-accordion-item [expanded]="false">
      <soft-ds-accordion-header>
        <soft-ds-accordion-leading variant="tinted">
          <soft-ds-icon name="fa-regular fa-clock-rotate-left" />
        </soft-ds-accordion-leading>
        <soft-ds-accordion-title variant="overline">
          Workflow-Verlauf
        </soft-ds-accordion-title>
      </soft-ds-accordion-header>
      <soft-ds-accordion-content>
        @if (history()?.length !== 0) {
          <soft-ds-timeline density="comfortable" nodeVariant="dot">
            @for (entry of history(); track entry.id; let last = $last) {
              <soft-ds-timeline-item [state]="last ? 'current' : 'completed'">
                <soft-ds-timeline-title>{{ entry.action }}</soft-ds-timeline-title>
                <soft-ds-timeline-meta>
                  {{ entry.username || 'kein username hinterlegt' }} -
                  {{ entry.time | date: 'dd.MM.yyyy HH:mm' }}
                </soft-ds-timeline-meta>
              </soft-ds-timeline-item>
            }
          </soft-ds-timeline>
        } @else {
          <soft-ds-empty-state [description]="'Kein Verlauf'" />
        }
      </soft-ds-accordion-content>
    </soft-ds-accordion-item>
  </soft-ds-accordion>
</section>
